import { MouseEventHandler } from "react";
import "./chip.css";
import { NumericFormat } from "react-number-format";

export interface LinkTextProps {
  onClick?: MouseEventHandler<HTMLSpanElement>;
  text?: string | number;
  isCurrency?: boolean
  preset?:
  | "default" | "paid" | "pending" | "draft" | "cancel" | "bluebox" | "greybox" | "onlinetext" | "offlinetext" | 'allBlue'
}

export const PRESETS = {
  default: "./chip.css",
  paid: "paid",
  success: "success",
  pending: "pending",
  draft: "draft",
  cancel: "cancel",
  bluebox: "bluebox",
  greybox: "greybox",
  onlinetext: "onlinetext",
  offlinetext: "offlinetext",
  allBlue: "set-as-default",
  completed: "completed"
};

function NoteneticChipText(props: LinkTextProps) {
  const { onClick, text, preset, isCurrency, ...others } = props;

  return (
    <div>
      <span
        className={preset ? PRESETS[preset] : PRESETS.default}
        onClick={onClick}
      >
        {isCurrency ?
          <NumericFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
          />
          : text}
      </span>
    </div>
  );
}

export default NoteneticChipText;
